import { ObliqClient } from "obliq-sdk";
import type {
	EstimateTransactionFeeResponse,
	SignAndSendTransactionResponse,
} from "obliq-sdk";
import { SOL_MINT } from "./utils";

const obliqClient = new ObliqClient({
	rpcUrl: import.meta.env.VITE_OBLIQ_RPC_URL ?? "https://your-obliq-server.example.com",
});

export type { EstimateTransactionFeeResponse, SignAndSendTransactionResponse };

export async function getObliqFeePayer(): Promise<string> {
	const { signer_address } = await obliqClient.getPayerSigner();
	return signer_address;
}

export async function estimateTransactionFee(
	transaction: string,
	feeToken = SOL_MINT,
): Promise<EstimateTransactionFeeResponse> {
	return obliqClient.estimateTransactionFee({ transaction, fee_token: feeToken });
}

export async function signAndSendTransaction(
	transaction: string,
): Promise<SignAndSendTransactionResponse> {
	return obliqClient.signAndSendTransaction({ transaction });
}
